import { InvestorsSectionCSS } from './InvestorsSectionCSS.styled'

export const InvestorsSection = () => (
  <InvestorsSectionCSS className='landing_level investors'>
    <div className='section_heading'>Investors who believe in us</div>
    <div className='logos'>
      <a href='https://panteracapital.com' target='blank' className='pantera'>
        <div className='logo'></div>
        <span>Pantera Capital</span>
      </a>
      <a href='https://www.cluster.vc' target='blank' className='cluster'>
        <div className='logo'></div>
        <span>Cluster Capital</span>
      </a>
      <a href='https://lemniscap.com' target='blank' className='lemniscap'>
        <div className='logo'></div>
        <span>LemnisCap</span>
      </a>
      <a href='https://www.deepventures.io' target='blank' className='deepventures'>
        <div className='logo'></div>
        <span>Deep Ventures</span>
      </a>
      <a href='https://www.angeldao.org' target='blank' className='angeldao'>
        <div className='logo'></div>
        <span>AngelDAO</span>
      </a>
      <a href='https://http://www.kretos.ventures/' target='blank' className='kretos'>
        <div className='logo'></div>
        <span>Kretos Ventures</span>
      </a>
    </div>
  </InvestorsSectionCSS>
)
